const openQuickShopModal = (product) => {
  // The "product" parameter contains values from the tolstoy spotlight carousel that you can use as a handle into which values to render on the modal.
  //You can check the values by logging it.
  console.log(product);
  console.log(product.handle);
  console.log(product.variants[0].id);
  // Please put your functions here
var getVarIdfromTolsToy = product.variants[0].id;

var Shopify1 = window.Shopify || {};

    var formData = {
        items: [{
            quantity: 1,
            id: getVarIdfromTolsToy // You need to use the variant ID here
        }]
    };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (data) {
            // Item successfully added to cart
             window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate,data)

             fetch("/cart.js") .then((response) => response.json())
             .then((data) => {
                console.log("Item added to cart", data.items[0]);
                setTimeout(function() {
                const e = document.querySelector("m-cart-drawer")
                e.onCartDrawerUpdate();
                document.querySelector('a[title="cart"]').click();
                }, 500);
             })
        },
        error: function (xhr, status, error) {
            console.log('Error adding to cart:', error);
        }
    });


  
}
//This Function is for the onClick Function on Tolstoy Spotlight Carousel "+" button
const subscribeToQuickShopClick =() =>  {
  window.tolstoyWidget.subscribe(
    "tolstoy_spotlight_carousel_quick_shop_click",
     (o) => {o.product && o.product.handle? openQuickShopModal(o.product): console.error("Product handle is not available in the event");},
    { disableDefault: !0 },
  );
}

window.tolstoyWidget ? subscribeToQuickShopClick(): window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);